import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import useMarketShareHooks from 'src/components/AtlasV2Components/Hooks/useMarketShareRequestHook';
import HoverTooltip from 'src/components/BeaconV2Components/HoverTooltip/HoverTooltip';
import { getFormattedMetricDateLabel } from 'src/components/BeaconV2Components/SplineChart/SplineChart';
import { formatMetric } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { ComparisonPeriod, useComparisonPeriod } from 'src/utils/Hooks';

const AtlasV2PricesPriceIndexSplineChart = () => {
  const comparisonPeriod = useComparisonPeriod();
  const theme = useStacklineTheme();
  const { requestBuilder, marketShareBuilder } = useMarketShareHooks();
  return (
    <AtlasV2ComparableSplineChart
      indexName="sales"
      fieldName="retailPriceMarketShareV2"
      title="Price Index"
      metricTypeDisplay={METRICTYPE.MULTIPLE}
      requestBuilder={requestBuilder}
      marketShareBuilder={marketShareBuilder}
      splineChartProps={{
        chartOptionsOverride: {
          yAxis: [
            {
              labels: {
                formatter() {
                  return `${formatMetric(this.value, METRICTYPE.MULTIPLE, {
                    decimalPlaces: 2,
                    showFullValue: false,
                    showNegative: true
                  })}x`;
                }
              }
            },
            {
              labels: {
                formatter() {
                  return `${formatMetric(this.value, METRICTYPE.MULTIPLE, {
                    decimalPlaces: 2,
                    showFullValue: false,
                    showNegative: true
                  })}x`;
                }
              }
            },
            {
              labels: {
                formatter() {
                  return `${formatMetric(this.value, METRICTYPE.MULTIPLE, {
                    decimalPlaces: 2,
                    showFullValue: false,
                    showNegative: true
                  })}x`;
                }
              }
            }
          ]
        },

        renderCustomTooltip: ({ primaryPoint, secondaryPoint, percentChange, weekId, metricType }) => {
          return ReactDOMServer.renderToStaticMarkup(
            <HoverTooltip
              theme={theme}
              title={`Week ${weekId % 100}`}
              primaryColor={(primaryPoint.color as string) || theme.colors.primary}
              primaryMetric={`${formatMetric(primaryPoint.y, metricType, {
                decimalPlaces: 2,
                showFullValue: false,
                showNegative: true
              })}x`}
              primaryMetricLabel={getFormattedMetricDateLabel(
                weekId,
                undefined,
                primaryPoint.series.index === 2 && comparisonPeriod === ComparisonPeriod.PRIOR_YEAR // the secondary series will always have index 2, subtract a year if comparing against prior year
              )}
              change={
                percentChange !== undefined
                  ? `${formatMetric(Math.abs(percentChange), METRICTYPE.PERCENT, { decimalPlaces: 2 })}`
                  : undefined
              } // get rid of negative sign if there is one
              rawChange={percentChange}
              secondaryMetric={
                secondaryPoint
                  ? `${formatMetric(secondaryPoint.y, metricType, {
                      decimalPlaces: 2,
                      showFullValue: false,
                      showNegative: true
                    })}x`
                  : ''
              }
              secondaryMetricLabel={getFormattedMetricDateLabel(
                weekId,
                undefined,
                comparisonPeriod === ComparisonPeriod.PRIOR_YEAR
              )}
              secondaryColor={secondaryPoint ? (secondaryPoint.color as string) : theme.colors.primaryLight}
            />
          );
        }
      }}
    />
  );
};

export default AtlasV2PricesPriceIndexSplineChart;
